import React, { Component } from 'react';

import { Transition } from "react-transition-group";
import Dropdown from 'react-bootstrap/Dropdown';
import Tooltip from 'react-bootstrap/Tooltip'
import Overlay from 'react-bootstrap/Overlay'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBook } from '@fortawesome/free-solid-svg-icons'

import './SideNavbar.css';


const rightStyles = {
  entering: {
    transition: 'all 1s ease',
    right: '0px',
  },
  entered: {
    right: '0px',
  },
  exiting: {
    transition: 'all 1s ease',
    right: '-64px',
  },
  exited: {
    right: '-64px',
  }
}


class SideNavbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expand: false,
      abortHint: 0,
    };
    this.toggleRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if(this.props.open && this.performHint('abort')) {
      return;
    }
  }

  reportIssue() {
    if (!this.props.onReportIssue) {
      return
    }
    this.props.onReportIssue()
  }

  abort() {
    if (!this.props.onAbort) {
      return
    }
    this.props.onAbort()
  }

  signOut() {
    if (!this.props.onSignOut) {
      return
    }
    this.props.onSignOut()
  }

  renderProgress() {
    if (!this.props.progress) {
      return null
    }
    const page = this.props.progress.page
    const sentence = this.props.progress.sentence
    if (page && page.all > 1) {
      return `${page.current + 1} / ${page.all} ページ`
    }
    return `${sentence.current + 1} / ${sentence.all} 文`
  }

  toPreviousPage() {
    if (!this.props.onPreviousPage) {
      return
    }
    this.props.onPreviousPage()
  }

  toNextPage() {
    if (!this.props.onNextPage) {
      return
    }
    this.props.onNextPage()
  }

  toFirstPage() {
    if (!this.props.onFirstPage) {
      return
    }
    this.props.onFirstPage()
  }

  toLastPage() {
    if (!this.props.onLastPage) {
      return
    }
    this.props.onLastPage()
  }

  resetContext() {
    if (!this.props.onResetContext) {
      return
    }
    this.props.onResetContext()
  }

  performHint(target) {
    if (this.props.hint === undefined) {
      return false
    }
    if (this.props.hint[target] === undefined) {
      // Too early
      return false;
    }
    if (this.props.hint[target]) {
      // Already performed
      return false
    }
    const propName = `${target}Hint`
    if (this.state[propName] !== 0) {
      return false
    }
    setTimeout(() => {
      const s = {}
      s[propName] = 1
      this.setState(s, () => {
        setTimeout(() => {
          const s2 = {}
          s2[propName] = 2
          this.setState(s2)
        }, 500)
      })
    }, 500)
    return true
  }

  hideHint(target) {
    const s = {}
    s[`${target}Hint`] = 3
    this.setState(s)

    if (!this.props.onHintPerform) {
      return
    }
    this.props.onHintPerform(target)
  }

  renderNavbar(state) {
    return (<div className='SideNavbarRoot' style={rightStyles[state]}>
      <div>
        <div className='SideNavbar'>
          <Dropdown>
            <Dropdown.Toggle ref={this.toggleRef}>
              <FontAwesomeIcon icon={faBook} onClick={() => this.setState({ expand: !this.state.expand })}/>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Header>{this.renderProgress()}</Dropdown.Header>
              <Dropdown.Item onClick={(e) => this.abort(e)}>
                中断
              </Dropdown.Item>
              {this.props.hasPreviousPage &&
                <Dropdown.Item onClick={(e) => this.toPreviousPage()}>
                  前のページ
                </Dropdown.Item>}
              {this.props.hasNextPage &&
                <Dropdown.Item onClick={(e) => this.toNextPage()}>
                  次のページ
                </Dropdown.Item>}
              {this.props.hasFirstPage &&
                <Dropdown.Item onClick={(e) => this.toFirstPage()}>
                  最初のページ
                </Dropdown.Item>}
              {this.props.hasLastPage &&
                <Dropdown.Item onClick={(e) => this.toLastPage()}>
                  最後のページ
                </Dropdown.Item>}
              {this.props.hasResetContext && <>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={(e) => this.resetContext()}>
                    回答経過を全てリセット
                  </Dropdown.Item>
                </>}
              {this.props.progress && <>
                <Dropdown.Divider />
                <Dropdown.Item onClick={e => this.reportIssue()}>
                  問題を報告
                </Dropdown.Item>
              </>}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <Overlay
        target={this.toggleRef.current}
        show={this.state.abortHint === 2}
        rootClose={true}
        onHide={() => this.hideHint('abort')}
        placement='left'>
        {(props) => (
          <Tooltip id='abort-tooltip' {...props}>
            タップして中断
          </Tooltip>
        )}
      </Overlay>
    </div>)
  }

  render() {
    return (<Transition in={this.props.open} timeout={1000} >
      {(state) => this.renderNavbar(state)}
    </Transition>)
  }
}

export default SideNavbar;
